import React, { useState, useEffect, useRef } from 'react';
import {
  Box, Avatar, Typography, AppBar, Toolbar, IconButton,
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { chatAPI } from '../../services/api';
import ProjectChat from '../../components/common/ProjectChat';
import ChatList, { chatInitials as initials } from '../../components/common/ChatList';
import PushBanner from '../../components/common/PushBanner';

/** Lista de chats: un chat por proyecto, el del ultimo mensaje arriba. */
export default function Chats({ onOpenChat, onUnreadChange }) {
  return (
    <Box>
      <PushBanner />
      <ChatList onOpenChat={onOpenChat} onUnreadChange={onUnreadChange} />
    </Box>
  );
}

/** Chat a pantalla completa, por encima de la navegacion de la app. */
export function ChatScreen({ projectId, onBack }) {
  const [project, setProject] = useState(null);

  useEffect(() => {
    chatAPI.messages(projectId, { limit: 1 })
      .then((res) => setProject(res.data.project))
      .catch(() => setProject(null));
  }, [projectId]);

  // El boton atras del movil cierra el chat en vez de salir de la app. onBack
  // va por ref para que un render del padre no apile otra entrada de historial.
  const onBackRef = useRef(onBack);
  onBackRef.current = onBack;
  useEffect(() => {
    window.history.pushState({ chat: projectId }, '');
    const onPop = () => onBackRef.current();
    window.addEventListener('popstate', onPop);
    return () => window.removeEventListener('popstate', onPop);
  }, [projectId]);

  const header = (
    <AppBar position="static" elevation={1}>
      <Toolbar sx={{ gap: 1, pl: 0.5 }}>
        <IconButton color="inherit" onClick={() => window.history.back()} aria-label="Volver">
          <ArrowBackIcon />
        </IconButton>
        <Avatar sx={{ bgcolor: '#fff', color: 'primary.main', width: 36, height: 36, fontSize: 15 }}>
          {initials(project?.name)}
        </Avatar>
        <Box sx={{ minWidth: 0 }}>
          <Typography variant="subtitle1" fontWeight={600} noWrap>{project?.name || 'Chat'}</Typography>
          <Typography variant="caption" noWrap component="div">
            {[project?.code, project?.client_name].filter(Boolean).join(' · ')}
          </Typography>
        </Box>
      </Toolbar>
    </AppBar>
  );

  // 100dvh: el alto real visible, que encoge al abrir el teclado del movil
  return (
    <Box sx={{ height: '100vh', '@supports (height: 100dvh)': { height: '100dvh' } }}>
      <ProjectChat projectId={projectId} header={header} />
    </Box>
  );
}
